import { ChangeDetectorRef, Component, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';
import { Utility } from 'src/app/core/common';
import { SharedService } from 'src/app/services/shared.service';

type optionType = (string | number | boolean);

@Component({
  selector: 'app-option-selector',
  templateUrl: './option-selector.component.html',
  styleUrls: ['./option-selector.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => OptionSelectorComponent),
    multi: true,
  },
  {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => OptionSelectorComponent),
    multi: true,
  }]
})
export class OptionSelectorComponent implements OnInit, ControlValueAccessor, Validator {
  Utility = Utility;
  required: boolean;

  constructor(element: ElementRef<HTMLElement>, private changeDetectorRef: ChangeDetectorRef, private sharedService: SharedService) {
    this.required = element.nativeElement.hasAttribute('required');
  }

  @Input() options: optionType[] = [];
  @Input() labels: string[];
  @Input() translation: Record<string, string>;
  @Input() canAdd = false;
  @Input() multiple = false;
  @Input() placeholder = 'سایر: تایپ کنید';
  @Input() itemClass = 'w-50';
  @Input() modelIsArray = true;

  selected: optionType[] | optionType;
  ngOnInit() {
    if (!this.labels && this.translation)
      this.labels = <string[]>this.sharedService.getReadable(this.options, this.translation);
  }

  validate(control: AbstractControl): ValidationErrors {
    return (
      !this.required ||
      (this.modelIsArray ? (<optionType[]>this.selected)?.length : (this.selected != null))
    ) ? null : { required: true };
  }

  writeValue(val: optionType[] | optionType): void {
    if (val == null) {
      delete this.selected;
    } else {
      this.selected = val;
      if (this.canAdd)
        this.options = Utility.concatUnique(this.options, this.modelIsArray ? <optionType[]>val : [val]);
    }
    this.changeDetectorRef.markForCheck();
  }
  registerOnChange(fn: any): void { this.propagateChange = fn; }
  registerOnTouched(fn: any): void { }
  private propagateChange = (_: any) => { };


  toggle(choice: optionType, forceAdd = false) {
    if (this.modelIsArray) {
      let choices = this.selected || [];
      let add = forceAdd || !Utility.isInArray(<optionType[]>choices, choice);
      if (add && !this.multiple) choices = [];
      Utility.setInArray(<optionType[]>choices, choice, add);
      choices = Utility.getUnique(<optionType[]>choices || []).filter(_ => _ != null);
      this.options = Utility.concatUnique(this.options, choices);
      this.selected = choices;
    } else {
      this.selected = choice;
      if (forceAdd)
        this.options = Utility.concatUnique(this.options, [choice]);
    }

    this.propagateChange(this.selected);
  }

  isSelected(choice: optionType): boolean {
    return this.modelIsArray
      ? Utility.isInArray(<optionType[]>this.selected, choice)
      : this.selected === choice;
  }

}
